import React, { useCallback, useEffect, useState } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { LegacyPage } from '@atlassian/jira-router-routes-common/src/ui/legacy-page/main.tsx';
import type { RouteContext } from '@atlassian/react-resource-router';
import WorkflowDiagramViewModal from '@atlassian/jira-workflow-view-diagram-modal/src/ui/index.tsx';

type Props = RouteContext;

export const ProjectSettingsWorkflows = (props: Props) => {
	const [selectedWorkflow, setSelectedWorkflow] = useState<string | undefined>(undefined);

	const handleOnClose = useCallback(() => {
		setSelectedWorkflow(undefined);
	}, [setSelectedWorkflow]);

	useEffect(() => {
		const handleClick = (event: Event) => {
			event.preventDefault();
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			const diagramLinkElement = event.currentTarget as Element;
			const workflowName = diagramLinkElement?.getAttribute('data-workflowname') || undefined;
			if (workflowName) {
				setSelectedWorkflow(workflowName);
			}
		};

		const workflowDiagramLinksElem = globalThis.document?.getElementsByClassName(
			'project-config-workflow-designer-link',
		);

		[...(workflowDiagramLinksElem ?? [])].forEach((diagramLink: Element) => {
			const workflowName = diagramLink.getAttribute('data-workflowname');
			if (workflowName) {
				diagramLink.addEventListener('click', handleClick);
			}
		});

		return () => {
			[...(workflowDiagramLinksElem ?? [])].forEach((diagramLink: Element) => {
				diagramLink.removeEventListener('click', handleClick);
			});
		};
	}, []);

	return (
		<JSErrorBoundary
			id="read-only-workflow-diagram-error-boundary"
			packageName="jiraRouterRoutesLegacyProjectSettingsWorkflowsEntries"
			teamName="helix"
			fallback="flag"
		>
			<LegacyPage {...props} />
			{selectedWorkflow && (
				<WorkflowDiagramViewModal
					workflowIdentifier={{ workflowName: selectedWorkflow }}
					isOpen
					onClose={handleOnClose}
				/>
			)}
		</JSErrorBoundary>
	);
};
